// src/app/modules/kumariRemitIpo/redux/constants.ts
export const KRI_CIF_LOOKUP_REQUEST = 'kumariRemitIpo/CIF_LOOKUP_REQUEST'
export const KRI_CIF_LOOKUP_SUCCESS = 'kumariRemitIpo/CIF_LOOKUP_SUCCESS'
export const KRI_CIF_LOOKUP_FAILURE = 'kumariRemitIpo/CIF_LOOKUP_FAILURE'
export const KRI_CIF_LOOKUP_RESET = 'kumariRemitIpo/CIF_LOOKUP_RESET'

export const KRI_FETCH_LIST_REQUEST = 'kumariRemitIpo/FETCH_LIST_REQUEST'
export const KRI_FETCH_LIST_SUCCESS = 'kumariRemitIpo/FETCH_LIST_SUCCESS'
export const KRI_FETCH_LIST_FAILURE = 'kumariRemitIpo/FETCH_LIST_FAILURE'

export const KRI_SUBMIT_REQUEST = 'kumariRemitIpo/SUBMIT_REQUEST'
export const KRI_SUBMIT_SUCCESS = 'kumariRemitIpo/SUBMIT_SUCCESS'
export const KRI_SUBMIT_FAILURE = 'kumariRemitIpo/SUBMIT_FAILURE'

export const KRI_FETCH_CASE_REQUEST = 'kumariRemitIpo/FETCH_CASE_REQUEST'
export const KRI_FETCH_CASE_SUCCESS = 'kumariRemitIpo/FETCH_CASE_SUCCESS'
export const KRI_FETCH_CASE_FAILURE = 'kumariRemitIpo/FETCH_CASE_FAILURE'

export const KRI_CHECKER_ACTION_REQUEST = 'kumariRemitIpo/CHECKER_ACTION_REQUEST'
export const KRI_CHECKER_ACTION_SUCCESS = 'kumariRemitIpo/CHECKER_ACTION_SUCCESS'
export const KRI_CHECKER_ACTION_FAILURE = 'kumariRemitIpo/CHECKER_ACTION_FAILURE'
